import React from 'react';

import PropTypes from 'prop-types';

import {
  Box,
  Link,
  makeStyles,
  Toolbar,
  Typography
} from '@material-ui/core';
import { EULA_URL, AFFILIATE_URL, PRIVACY_POLICY_URL } from 'src/constants';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default
  },
  toolbar: {
    height: 64
  },
  logo: {
    marginRight: theme.spacing(2)
  },
  link: {
    fontWeight: theme.typography.fontWeightMedium,
    '& + &': {
      marginLeft: theme.spacing(2)
    }
  },
  divider: {
    width: 1,
    height: 32,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2)
  }
}));

const BottomBar = ({ className, ...rest }) => {
  const classes = useStyles();

  return (
      <Toolbar className={classes.toolbar}>
        <Typography
          variant="body2"
          color="textSecondary"
        >
          Copyright GameBuddy Inc. 2021 All Rights Reserved
        </Typography>
        <Box flexGrow={1} />
        <Link
          className={classes.link}
          color="textSecondary"
          component={Link}
          onClick={(e)=>{
            window.location=AFFILIATE_URL
          }}
          underline="none"
          variant="body2"
        >
          Afilliate Program
        </Link>
        <Link
          className={classes.link}
          color="textSecondary"
          underline="none"
          variant="body2"
          component={Link}
          onClick={(e)=>{
            window.location=EULA_URL
          }}
        >
          EULA
        </Link>
        <Link
          className={classes.link}
          color="textSecondary"
          underline="none"
          variant="body2"
          component={Link}
          onClick={(e)=>{
            window.location=PRIVACY_POLICY_URL
          }}
        >
          Privacy Policy
        </Link>
      </Toolbar>
  );
};

BottomBar.propTypes = {
  className: PropTypes.string
};

export default BottomBar;
